export default "__VITE_ASSET__CXsetxir__"